<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<div class="row" style="margin-top:60px">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-12 text-center">
              <h4 style="font-family: open sans; color:#9b7544"><strong>Add Documents</strong></h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row" style="margin:1%" *ngIf="uploadingflag == 0">
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <button class="btn btn-success btn-block"  *ngIf= "AdoptionDocument &&
              AdoptionDocument.length === 0"  (click)="addDocument()">Upload  Document</button>
              <button class="btn btn-secondary btn-block"  *ngIf= "AdoptionDocument &&
              AdoptionDocument.length > 0"  (click)="addDocument()">Upload Another Document</button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <button *ngIf="AdoptionDocument && AdoptionDocument.length> 0" class="btn btn-success3 btn-block"  (click)="showFinalmessage()">Complete post</button>
              </div>

          </div>
          <div class="row" style="margin:1%"  *ngIf= "uploadingflag == 0
          && AdoptionDocument && AdoptionDocument.length> 0">
          <div class="col-12" *ngFor="let doc of AdoptionDocument">
            <div class="row">
                <div class="col-4">
                    Doc Type: {{doc.document_type}}
                  </div>
                  <div class="col-4">
                    File Name: {{doc.path}}
                    </div>
                    <div class="col-4" style="color:#9b7544">
                       <mat-icon>done all</mat-icon> Uploaded
                      </div>
            </div>

          </div>
            </div>
          <div class="row"  *ngIf="uploadingflag == 1">
            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 text-center">
                <div class="form-group" >
                    <label>Document Type</label>
                    <select type="text" name="doc" id="doc"  [(ngModel)]="doctype" class="form-control">
                      <option value="kci">kci</option>
                      <option value="health">Health Record</option>
                      </select>
                    </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 " style="margin:2%" *ngIf="doctype" >
                <div class="form-group">
                      <input type="file" name="photo" ngFileSelect [options]="options" (onUpload)="handleUploaddoc($event)" (beforeUpload)="beforeUploaddoc($event)"  ngModel class="form-control" required>
                </div>
            </div>
            <div class="col-12 text-center" style="margin-bottom:2px">
              <button class="btn btn-secondary contact-btn" *ngIf="filename && doctype" (click)="setAdoptionDocumentpath()">Upload</button>
            </div>
          </div>

          <div class="row" style="margin-top:2%" *ngIf="uploadingflag == 2">
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <label style="font-style: open sans; color:#9b7544; font-size:22px">
                <span><strong>Upload Successful</strong></span>
              </label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-secondary btn-block" (click)="CancelUpload()">Ok</button>
              </div>
          </div>
        </div>
        <div class="card-footer"  *ngIf="uploadingflag == 1">
            <div class="row" >
                <div class="col-12 text-center" style="margin:1%">
                  <button class="btn btn-success btn-block" (click)="CancelUpload()">cancel upload</button>
                </div>
                </div>
        </div>
      </div>
    </div>
  </div>
    <div class="row" *ngIf="otpconfirm === 4" style="margin-top:2%">
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:2%">
            <label style="font-family: open sans; color: #9b7544; font-size:22px;overflow-wrap: break-word">
              <span><strong>Your Adoption Detail Has Been Uploaded Successfully.  ** This Post wll be published after verification.
                Verificaion is expected to be complete with in 24 hours
                </strong></span>
            </label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" >
            <button class="btn btn-success btn-block" routerLink="/petadoption/home">Ok</button>
          </div>
    </div>
